<div class="card-header">
    <div class="ellipsis"><h2>{{ header }}</h2></div>
</div>